import React from 'react';
import { Helmet } from 'react-helmet-async';
import './About.css';
import SearchScreenNav from '../components/SearchScreenNav';

const About = () => {
  return (
    <div className="about-page-container">
      <Helmet>
        <title>About Us | LGBT PridePath</title>
        <meta name="description" content="Learn about the LGBT National Help Center, serving the LGBTQ+ community since 1996 with free, confidential peer support, hotlines, and resources." />
        <link rel="canonical" href="https://www.lgbtpridepath.org/about" />
      </Helmet>
      
      {/* Custom navigation for overlay effect */}
      <SearchScreenNav />
      
      {/* Hero image container - positioned OUTSIDE content wrapper like video in SearchScreen */}
      <div className="about-hero-image-container">
        <img src={require('../assets/header-about.png')} alt="Community member" />
      </div>
      
      {/* Content wrapper matching SearchScreen structure */}
      <div className="about-content-wrapper">
        {/* Hero section - like info-section in SearchScreen */}
        <div className="about-hero-section">
          <h2 className="about-hero-subtitle">ABOUT US</h2>
          <h1 className="about-hero-title">We are Here to Serve and Uplift the Community</h1>
        </div>
      </div>

      {/* Mission Section - appears on white background from pseudo-element */}
      <section className="about-mission-section">
        <div className="about-mission-content">
          <div className="about-mission-image">
            <img src={require('../assets/aboutlowercircle.png')} alt="Team member" />
            <div className="about-mission-image-overlay">
              <h3>Our Mission<br/>From the Start</h3>
            </div>
          </div>
          <div className="about-mission-text">
            <div className="about-section-header"></div>
            <div className="about-services-box">
              <h3>OUR SERVICES ARE ALWAYS FREE & CONFIDENTIAL</h3>
              <ul>
                <li>Peer support staffed by trained LGBTQIA+ identified community members, never bots or AI</li>
                <li>A safe space</li>
                <li>Respect to those who seek our help</li>
                <li>Acceptance and affirmation</li>
                <li>Supportive listening, not advice</li>
                <li>Answers to factual questions</li>
                <li>Resources locally, nationally, and internationally</li>
              </ul>
              <p className="about-mission-statement">
                We do this every day we are open through our hotlines, online chat programs, email services, and publicly accessible online databases of resources.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Who We Are Section */}
      <section className="about-who-section">
        <div className="about-who-content">
          <div className="about-who-text">
            <div className="about-section-header"></div>
            <div className="about-history-box">
              <h3>OUR HISTORY & MISSION</h3>
              <p>
                The Lesbian, Gay, Bisexual, and Transgender (LGBT) National Help Center, founded in 1996, is a non-profit, tax-exempt organization that provides vital peer support, community connections, and resource information through helplines and online chatrooms. Our services focus on sexual orientation and/or gender identity and expression. We are the oldest and most comprehensive national organization of its type and scope in the United States, providing critically needed services regardless of age or geographic location.
              </p>
              <p>
                We help youth and adults with coming-out issues, safer-sex information, school bullying, family concerns, relationship problems, and a lot more. The people who turn to us for help often live in rural and conservative parts of the country and are frequently feeling severely isolated, closeted and in despair, with literally no one else safe to talk to.
              </p>
              <p>
                We care deeply about confidentiality. We understand that what is discussed with us is private.
              </p>
            </div>
          </div>
          <div className="about-who-image">
            <img src={require('../assets/aboutpagelowerbottom.png')} alt="Founder" />
            <div className="about-who-image-overlay">
              <h3>Who We Are</h3>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;